import { Card, CardContent, CardFooter, CardHeader } from "./ui/card"
import { Button } from "../components/ui/button"
import { Check } from "lucide-react"
import { Phone, Calendar } from "lucide-react"
import { Link } from "react-router-dom"


export function PackageCard({ title, price, description, tests, featured = false, href }) {
  return (
    <Card
      className={`transition-all ${
        featured ? "border-primary shadow-lg relative" : "hover:shadow-md"
      } hover:translate-y-[-5px] duration-300 group`}
    >
      {featured && (
        <div className="absolute top-0 right-0 px-3 py-1 text-xs font-medium text-white transform translate-x-2 -translate-y-2 bg-primary rounded-full">
          Recommended
        </div>
      )}
      <CardHeader className={`pb-2 ${featured ? "bg-primary/10" : "group-hover:bg-gray-100"} transition-colors`}>
        <h3 className="text-xl font-bold">{title}</h3>
        <div className="flex items-baseline mt-2">
          <span className="text-2xl font-bold text-primary">{price}</span>
          <span className="ml-1 text-muted-foreground">/person</span>
        </div>
      </CardHeader>
      <CardContent className="pt-4">
        <p className="mb-4 text-muted-foreground">{description}</p>
        <ul className="space-y-2">
          {tests.map((test, index) => (
            <li key={index} className="flex items-start">
              <Check className="w-5 h-5 mr-2 text-green-500 shrink-0" />
              <span>{test}</span>
            </li>
          ))}
        </ul>
      </CardContent>
      <CardFooter>
        <Button className="w-full" variant={featured ? "default" : "outline"} asChild>
          <a
             href="https://pranaam365.com/book-tests"
            rel="noopener noreferrer"
          >
            <Calendar className="mr-2 h-5 w-5" />
            Book Now
          </a>
        </Button>
      </CardFooter>
    </Card>
  )
}
